import { travelDateLocalized } from '@/utils/travels'
import { ClientFileStatus } from '@/enum'

const statusColors = {
  [ClientFileStatus.INCOMPLETE]: 'grey',
  [ClientFileStatus.REQUESTED]: 'blue',
  [ClientFileStatus.SAVED]: 'green',
  [ClientFileStatus.LOST]: 'red'
}

export class FileTimelineEntry {
  constructor ({
    id = 0,
    fileId = 0,
    timestamp = 0,
    status = ''
  } = {}) {
    this.id = id
    this.fileId = fileId
    this.timestamp = timestamp != null ? new Date(timestamp * 1000) : new Date()
    this.status = status
  }

  get formattedFileTimestamp () {
    return travelDateLocalized(this.timestamp)
  }

  get statusColor () {
    if (this.status in statusColors) {
      return statusColors[this.status]
    } else {
      return 'primary'
    }
  }
}
